/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../common";
import type { RewardRouter, RewardRouterInterface } from "../RewardRouter";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "StakeMoney",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "StakeMlp",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "UnstakeMoney",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "UnstakeMlp",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_sender",
        type: "address",
      },
    ],
    name: "acceptTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_accounts",
        type: "address[]",
      },
    ],
    name: "batchCompoundForAccounts",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amounts",
        type: "uint256[]",
      },
    ],
    name: "batchStakeMoneyForAccount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "bnMoney",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "bonusMoneyTracker",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "claimEsMoney",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "claimFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "compound",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "compoundForAccount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "esMoney",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "feeMoneyTracker",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "feeMlpTracker",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "gov",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_shouldClaimMoney",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "_shouldStakeMoney",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "_shouldClaimEsMoney",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "_shouldStakeEsMoney",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "_shouldStakeMultiplierPoints",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "_shouldClaimWeth",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "_shouldConvertWethToEth",
        type: "bool",
      },
    ],
    name: "handleRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "_weth",
            type: "address",
          },
          {
            internalType: "address",
            name: "_money",
            type: "address",
          },
          {
            internalType: "address",
            name: "_esMoney",
            type: "address",
          },
          {
            internalType: "address",
            name: "_bnMoney",
            type: "address",
          },
          {
            internalType: "address",
            name: "_mlp",
            type: "address",
          },
          {
            internalType: "address",
            name: "_stakedMoneyTracker",
            type: "address",
          },
          {
            internalType: "address",
            name: "_bonusMoneyTracker",
            type: "address",
          },
          {
            internalType: "address",
            name: "_feeMoneyTracker",
            type: "address",
          },
          {
            internalType: "address",
            name: "_feeMlpTracker",
            type: "address",
          },
          {
            internalType: "address",
            name: "_stakedMlpTracker",
            type: "address",
          },
          {
            internalType: "address",
            name: "_mlpManager",
            type: "address",
          },
          {
            internalType: "address",
            name: "_moneyVester",
            type: "address",
          },
          {
            internalType: "address",
            name: "_mlpVester",
            type: "address",
          },
        ],
        internalType: "struct RewardRouterV2.initParams",
        name: "params",
        type: "tuple",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "isInitialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "money",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "moneyVester",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mlp",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mlpManager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mlpVester",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minUsdg",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minMlp",
        type: "uint256",
      },
    ],
    name: "mintAndStakeMlp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_minUsdg",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minMlp",
        type: "uint256",
      },
    ],
    name: "mintAndStakeMlpETH",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "pendingReceivers",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_gov",
        type: "address",
      },
    ],
    name: "setGov",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
    ],
    name: "signalTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "stakeEsMoney",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "stakeMoney",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "stakeMoneyForAccount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "stakedMoneyTracker",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stakedMlpTracker",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_mlpAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minOut",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
    ],
    name: "unstakeAndRedeemMlp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_mlpAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minOut",
        type: "uint256",
      },
      {
        internalType: "address payable",
        name: "_receiver",
        type: "address",
      },
    ],
    name: "unstakeAndRedeemMlpETH",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "unstakeEsMoney",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "unstakeMoney",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "weth",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdrawToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type RewardRouterConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: RewardRouterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class RewardRouter__factory extends ContractFactory {
  constructor(...args: RewardRouterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      RewardRouter & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): RewardRouter__factory {
    return super.connect(runner) as RewardRouter__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RewardRouterInterface {
    return new Interface(_abi) as RewardRouterInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): RewardRouter {
    return new Contract(address, _abi, runner) as unknown as RewardRouter;
  }
}
